import {SpanIcon} from '@mazraeapp/react_icon_kit';
import React, {useState} from 'react';
import {BottomSheet} from 'react-spring-bottom-sheet';
import useDeleteChat from '../../../../services/hookService/chats/deleteChat/useDeleteChat';
import {useNavigate} from 'react-router-dom';
import DotsLoading from '../../../../components/dotsLoading';
import usePatchBanText from '../../../../services/hookService/chats/patchBanText/usePatchBanText';

interface ChatReportProps {
  isReportOpen: boolean;
  isDeleteOpen: boolean;
  userChatDetailData: IGetUserCHatDetailData | undefined;
  setIsReportOpen: (item: boolean) => void;
  setIsDeleteOpen: React.Dispatch<React.SetStateAction<boolean>>;
}
const ChatReport = ({
  isReportOpen,
  isDeleteOpen,
  userChatDetailData,
  setIsReportOpen,
  setIsDeleteOpen,
}: ChatReportProps) => {
  const navigate = useNavigate();
  const [isEmptyMsg, setisEmptyMsg] = useState(false);
  const [reportText, setReportText] = useState('');
  const {isLoading, mutate} = useDeleteChat({
    onSuccess: () => {
      navigate('/my-chats');
      setIsReportOpen(false);
      setReportText('');
    },
  });
  const {mutateBanChat, isLoadingBanChat} = usePatchBanText({
    guid: userChatDetailData?.guid,
    onSuccessAction: () => {
      setIsReportOpen(false);
      setReportText('');
    },
  });
  return (
    <>
      <BottomSheet
        onDismiss={() => setIsDeleteOpen(false)}
        open={isDeleteOpen}
        blocking={true}
        snapPoints={({minHeight, maxHeight}) => [minHeight, maxHeight / 0.6]}
      >
        <div className="flex flex-col w-full px-3 gap-3 pb-4">
          <div className="flex w-full justify-between">
            <SpanIcon className="icon-nameDelete text-[24px] text-red-500" />
            <button onClick={() => setIsDeleteOpen(false)}>
              <SpanIcon className="icon-nameClose-remove text-[24px]  text-gray-700" />
            </button>
          </div>
          <div className="flex flex-col gap-3">
            <div className="text-gray-950 font-Medium text-xl">حذف چت</div>
            <div className="text-gray-700 font-Medium text-md">
              آیا اطمینان به حذف چت دارید؟
            </div>
          </div>
          <div className="w-full  flex justify-between">
            <button
              disabled={isLoading}
              className="w-[45%] border-[1px] border-farm-shop-500 h-[48px] text-farm-shop-500 flex items-center justify-center text-md font-Medium rounded-[8px]"
              onClick={() => {
                mutate(userChatDetailData?.guid);
              }}
            >
              {isLoading ? <DotsLoading /> : 'بله،حذف شود'}
            </button>
            <button
              className="w-[45%] h-[48px] bg-farm-shop-500  text-white flex items-center justify-center text-md font-Medium rounded-[8px]"
              onClick={() => {
                setIsDeleteOpen(false);
              }}
            >
              انصراف
            </button>
          </div>
        </div>
      </BottomSheet>
      <BottomSheet
        onDismiss={() => setIsReportOpen(false)}
        open={isReportOpen}
        blocking={true}
        snapPoints={({minHeight, maxHeight}) => [minHeight, maxHeight / 0.6]}
      >
        <div className="flex flex-col w-full px-3 gap-3 py-3">
          <p className="text-gray-950 text-md font-Medium">
            دلیل گزارش تخلف را بنویسید
          </p>
          <textarea
            placeholder="دلیل گزارش.."
            id="w3review"
            name="w3review"
            value={reportText}
            className="w-full rounded-[8px] border-[1px] focus:outline-none !border-gray-400 h-[158px] p-3"
            onChange={e => {
              setReportText(e.target.value);
              setisEmptyMsg(false);
            }}
          />
          {isEmptyMsg && (
            <p className="text-red-700 text-xs font-Regular pr-2">
              پیام نمی تواند خالی باشد
            </p>
          )}
          <div className="w-full  flex justify-between">
            <button
              disabled={isLoadingBanChat}
              className="w-[45%] border-[1px] border-farm-shop-500 h-[48px] text-farm-shop-500 flex items-center justify-center text-md font-Medium rounded-[8px]"
              onClick={() => {
                reportText.length > 0
                  ? mutateBanChat({banned_text: reportText})
                  : setisEmptyMsg(true);
              }}
            >
              {isLoadingBanChat ? <DotsLoading /> : 'ثبت گزارش'}
            </button>
            <button
              className="w-[45%] h-[48px] bg-farm-shop-500  text-white flex items-center justify-center text-md font-Medium rounded-[8px]"
              onClick={() => {
                setIsReportOpen(false);
                setReportText('');
              }}
            >
              انصراف
            </button>
          </div>
        </div>
      </BottomSheet>
    </>
  );
};

export default ChatReport;
